import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;
/** Agent workbench uses list/detail toggle below this width (sidebar + 3 columns need ~1280px). */
const AGENT_COMPACT_BREAKPOINT = 1280;

function useMediaQuery(maxWidth: number): boolean {
  const [matches, setMatches] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth - 1}px)`);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [maxWidth]);

  return matches ?? false;
}

/** True when viewport width is below the md breakpoint (768px). */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_BREAKPOINT);
}

/** Agent/Super Agent tickets — compact layout below 1280px (list/detail + stacked panels). */
export function useAgentCompactLayout(): boolean {
  return useMediaQuery(AGENT_COMPACT_BREAKPOINT);
}
